import {createContext, useContext} from 'react'

export interface CustomGoSchoolConfig {
  siteIcon: string;
  siteTitle: string;
  organizationId?: string;
}

export const CustomGoSchoolContext = createContext<CustomGoSchoolConfig | undefined>(undefined)

export function useCustomGoSchool() {
  const context = useContext(CustomGoSchoolContext)
  if (!context) {
    throw new Error('useCustomGoSchool must be used within a CustomGoSchoolContextProvider')
  }
  return context
}
